import {AddressDto} from '@sportngin/se-commerce-sdk';
import {CartComparator} from './cart-comparator';
import {FactoryFn} from './factory-function';
export class Address implements CartComparator<Address> {
  address1: string;
  address2?: string;
  city: string;
  country: string;
  state: string;
  zip: string;

  constructor(source?: {
    address1: string;
    address2?: string;
    city: string;
    country: string;
    state: string;
    zip: string;
  }) {
    if (!source) return;

    this.address1 = source.address1;
    this.address2 = source.address2;
    this.city = source.city;
    this.country = source.country;
    this.state = source.state;
    this.zip = source.zip;
  }

  equals(a: Address, b: Address = this): boolean {
    return (
      a === b ||
      (a.address1 === b.address1 &&
        a.address2 === b.address2 &&
        a.city === b.city &&
        a.country === b.country &&
        a.state === b.state &&
        a.zip === b.zip)
    );
  }
}

export const addressDtoToAddress: FactoryFn<AddressDto, Address> = (
  source: AddressDto | null,
) => {
  return new Address({
    address1: source?.address1 ?? '',
    address2: source?.address2 ?? undefined,
    city: source?.city ?? '',
    country: source?.country ?? '',
    state: source?.state ?? '',
    zip: source?.zip ?? '',
  });
};
